import { useAppContext } from '../AppContext';

export const IsB2bAgent = (): boolean => {
  const { agent } = useAppContext();

  return agent?.getRoutingProfile().name.toLowerCase().includes('bjou') || false;
};
